import { ICompanyData } from "./types";
import { Image } from "react-bootstrap";
import Table, { LinkColumn } from "../../components/Table/index";
import { ColumnDef } from "@tanstack/table-core";
import { titleConvert } from "./../../helpers/api/utils";
import { DEV_URL, HUBSPOT_BASE_URL, rpost } from "utils/requests";
import Text from "components/Text";
import FlagIcon from "components/icons/FlagIcon";
import { ISubscribeOptions, SubscribeModal } from "./SubscribeModal";
import { useEffect, useRef, useState } from "react";
import ThreeDotMenu from "components/ThreeDotMenu";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import MergeCompanyComponent, { MergeCompanyProps } from "./MergeCompany";
import { useAuth } from "providers/CustomAuthProvider";
import enerexLogo from 'assets/images/enerexLogo.svg';
import { buildCompanyLogoUrl } from 'utils/logo';
import useShowSnackbar from "hooks/useShowSnackbar";
import useGlobalPremiumFlag from "hooks/useGlobalPremiumFlag";

type CompaniesDataProps = {
  companies?: ICompanyData[];
  hiddenColumns?: string[];
  enableActions?: boolean;
  loading?: boolean;
  total?: number;
  hook?: any;
  pageNo?: number;
  filters?: any;
  extra?: any;
};
const imageerror = (e) => {
  e.target.style.display = "none";
};


export const CompaniesDataTable = ({
  companies,
  loading,
  total,
  hook,
  filters,
  hiddenColumns,
  enableActions = false,
  extra,
}: CompaniesDataProps) => {
    
    const { isSystemAdmin } = useAuth(); 
    const isPremium = useGlobalPremiumFlag();
    const mergeCompanyRef = useRef<MergeCompanyProps | null>(null);
    const premiumBlurStyle = (isPremium: boolean): React.CSSProperties =>
        isPremium
            ? {}
            : {
                filter: "blur(4px)",
                userSelect: "none",
                pointerEvents: "none",
              };
    const snackbar = useShowSnackbar();
    const columns: ColumnDef<ICompanyData>[] = [
        {
            header: "Company Name",
            accessorKey: "legalName",
            enableSorting: true,
            cell: (props) => {
              const status = props.row.original.companyStatus;
              const normalizedStatus = status?.trim().toLowerCase();
              const dotColor = normalizedStatus === "active" ? "#28a745" : "#dc3545";
              const handleCopyEcid = async (ecid: string) => {
                try {
                  await navigator.clipboard.writeText(ecid);
                  snackbar("ECID copied", "success");
                } catch (error) {
                  snackbar("Unable to copy ECID", "error");
                }
              };
              const ecid = props.row.original.enerexCompanyId?.trim();
               const ecidLabel = null; 
               //ecid ? (
              //   <button
              //     type="button"
              //     aria-label="Copy ECID"
              //     title="Copy ECID"
              //     onClick={(e) => {
              //       e.preventDefault();
              //       e.stopPropagation();
              //       handleCopyEcid(ecid);
              //     }}
              //     className="text-muted"
              //     style={{
              //       alignSelf: "flex-start",
              //       background: "transparent",
              //       border: "1px solid #ced4da",
              //       borderRadius: "4px",
              //       display: "inline-flex",
              //       alignItems: "center",
              //       gap: "3px",
              //       marginTop: "2px",
              //       padding: "1px 5px",
              //       fontSize: "10px",
              //       lineHeight: "1.2",
              //       whiteSpace: "nowrap",
              //       cursor: "pointer",
              //     }}
              //   >
              //     <i className="uil uil-copy" aria-hidden="true"></i>
              //     <small>{ecid}</small>
              //   </button>
              // ) : null;
              const statusIcon = (
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    display: "inline-block",
                    flexShrink: 0,
                    ...(normalizedStatus
                      ? {
                        borderRadius: "50%",
                        backgroundColor: dotColor,
                      }
                      : {}),
                  }}
                />
              );
                if (props.row.original.emailDomain === null || props.row.original.emailDomain === '') {
                    return (
                    <div className="d-flex">
                        <div className="d-flex align-items-center">
                          {statusIcon}
                          <div className="image-container-logo">
                          </div>
                        {
                          props.row.original.isSubscribe ? <FlagIcon style={{ margin: '7px 0', fontSize: '0.8rem' }} className='light-green me-3' /> : <FlagIcon style={{ margin: '7px 0', fontSize: '0.8rem' }} className='light-gray me-3' />
                        }
                        <div className="d-flex flex-column">
                          <LinkColumn className="company-name" value={titleConvert(props.row.original.legalName.trim())} url={`/companies/${props.row.original.id}`} />
                          {ecidLabel}
                        </div>
                      </div>
                        <button 
                            onClick={()=>{if (isPremium) followCompany(props.row.original.id,props.row.original.isSubscribe,props.row.index)}} 
                            className={`follow-button btn`}
                            disabled={!isPremium}
                            style={{ cursor: !isPremium ? 'not-allowed' : 'pointer' }}
                        >
                            {props.row.original.isSubscribe?'Unfollow':'Follow'}
                        </button>
                    </div>);
                }
                return <div className="d-flex">
                    <div className="d-flex align-items-center">
                        {statusIcon}
                        <div className="image-container-logo">
                            <Image
                                alt="logo images"
                                onError={imageerror}
                                src={buildCompanyLogoUrl(props.row.original.emailDomain)}
                            />
                        </div>
                            {
                                props.row.original.isSubscribe ?<FlagIcon  style={{margin:'7px 0',fontSize:'0.8rem'}} className='light-green me-3'/>:<FlagIcon  style={{margin:'7px 0',fontSize:'0.8rem'}} className='light-gray me-3'/>
                            }
                        <div className="d-flex flex-column">
                          <LinkColumn className="company-name" value={titleConvert(props.row.original.legalName.trim())} url={`/companies/${props.row.original.id}`} />
                          {ecidLabel}
                        </div>
                    </div>
                    <button 
                        onClick={()=>{if (isPremium) followCompany(props.row.original.id,props.row.original.isSubscribe,props.row.index)}} 
                        className={`follow-button btn`}
                        disabled={!isPremium}
                        style={{ cursor: !isPremium ? 'not-allowed' : 'pointer' }}
                    >
                        {props.row.original.isSubscribe?'Unfollow':'Follow'}
                    </button>    
                </div>
            },
        },
        {
            header: "Domain",
            accessorKey: "emailDomain",
            enableSorting: true,
            cell: (props) => {
                // TODO: find better approach such that www is removed from API or crawler end itself
                const wwwRemover = domain => (domain?.replace(/^www\d?\./i, '') || '');
                const domainValue = ((props.row.original.emailDomain === null || props.row.original.emailDomain === undefined) ? '' : wwwRemover(props.row.original.emailDomain));
                return (
                    <Text variant="link" url={((props.row.original.emailDomain === null || props.row.original.emailDomain === undefined) ? '' : 'http://' + props.row.original.emailDomain)}>
                        {domainValue}
                    </Text>
                );
            },
        },
        {
            header: "Parent Company",
            accessorKey: "parentCompanyName",
            enableSorting: false,
            cell: (props) => {
                const parentName = props.row.original.parentCompanyName;
                const parentId = props.row.original.parentCompanyId;

        if (!parentName) {
          return <span>-</span>;
        }

                if (!isPremium) {
                    return <span style={premiumBlurStyle(false)}>{parentName}</span>;
                }

        if (!parentId) {
          return <span>{parentName}</span>;
        }

        return (
          <LinkColumn value={parentName} url={`/companies/${parentId}`} />
        );
      },
    },
    {
      header: "# Contacts",
      accessorKey: "contactCount",
      enableSorting: true,
      cell: (props) => {
        return (
          <span>{`${
            props.row.original.contactCount === null ||
            props.row.original.contactCount === undefined
              ? ""
              : props.row.original.contactCount
          }`}</span>
        );
      },
    },
    {
      header: "# Licenses",
      accessorKey: "licenseCount",
      enableSorting: true,
      cell: (props) => {
        return (
          <span>{`${
            props.row.original.licenseCount === null ||
            props.row.original.licenseCount === undefined
              ? ""
              : props.row.original.licenseCount
          }`}</span>
        );
      },
    },
    {
      header: "License Type",
      accessorKey: "licenseType",
      enableSorting: false,
      cell: (props) => {
                const licenseType =
                    (props.row.original.licenseType === undefined ||
                    props.row.original.licenseType === null ||
                    props.row.original.licenseType === "")
                        ? "N/A"
                        : props.row.original.licenseType;
                return <span style={premiumBlurStyle(isPremium)}>{licenseType}</span>
      },
    },
    {
      header: "Action",
      accessorKey: "isSubscribe",
      enableSorting: false,
      cell: (props) => {
        let hubspotBtn;
        let enerexAdminBtn;
        const hubspotId = props.row.original.hubspotId?.trim();
        const hubspotUrl =
          HUBSPOT_BASE_URL && hubspotId ? `${HUBSPOT_BASE_URL}${hubspotId}` : "";

        if (hubspotUrl) {
          hubspotBtn = (
            <DropdownItem
              onClick={(e) => {
                const a = document.createElement("a");
                a.href = hubspotUrl;
                a.target = "_blank";
                a.click();
              }}
            >
              <small>
                <i className="mdi mdi-hubspot me-1" style={{ color: "#ff7a59" }}></i>
                Hubspot
              </small>
            </DropdownItem>
          );
        }
        if (props.row.original.enerexAdminUrl) {
          enerexAdminBtn = (
            <DropdownItem
              onClick={(e) => {
                const a = document.createElement("a");
                a.href = props.row.original.enerexAdminUrl;
                a.target = "_blank";
                a.click();
              }}
            >
              <small>
                <img src={enerexLogo} height="16px" />
                Enerex Admin
              </small>
            </DropdownItem>
          );
        }
        return (
          <ThreeDotMenu className="text-center">
            <DropdownItem
              disabled={!isPremium}
              onClick={(e) => {
                if (isPremium) {
                  followCompany(
                    props.row.original.id,
                    props.row.original.isSubscribe,
                    props.row.index,
                  );
                }
              }}
              style={{ cursor: !isPremium ? "not-allowed" : "pointer" }}
            >
              <small>
                {props.row.original.isSubscribe ? (
                  <FlagIcon
                    style={{ fontSize: "0.8rem" }}
                    className="light-green"
                  />
                ) : (
                  <FlagIcon
                    style={{ fontSize: "0.8rem" }}
                    className="light-gray"
                  />
                )}
                {props.row.original.isSubscribe ? " Unfollow" : " Follow"}
              </small>
            </DropdownItem>

            {isSystemAdmin && (
              <>
                {hubspotBtn}
              </>
            )}
              {isSystemAdmin && (
              <DropdownItem
                onClick={(e) => {
                  if (mergeCompanyRef.current) {
                    mergeCompanyRef.current.onShowMergeCompany(
                      props.row.original,
                    );
                  }
                }}
              >
                <i className="mdi mdi-source-merge me-1"></i>
                <small>Merge</small>
              </DropdownItem>
            )}
          </ThreeDotMenu>
        );
      },
    },
  ];
  const [selectedValue, setSelectedValue] = useState<ISubscribeOptions>({
    email: false,
    push: false,
    sms: false,
    web: false,
  });
  const followCompany = async (companyId, isSubscribed, index) => {
    const response = await rpost(
      `${DEV_URL}/api/Company/SubscribeNotification`,
      {
        CompanyId: companyId,
        IsSubscribe: !isSubscribed,
      },
    );

    if (response !== "Data not found") {
      if (response.data.includes("Notifications")) {
        companies[index].isSubscribe = !isSubscribed;
        extra.setCompanyData([...companies]);
      }
    }
  };
  const onSubmit = (reponseData) => {};
  const [selectedCompnay,setSelectedCompnay] = useState("");
  const [isModalShow,setIsModalShow] = useState(false);
  const onModalPopup: Function = (companyId, isSubscribed, subscribeTypes) => {
    setSelectedCompnay(companyId);
    setIsModalShow(true);
    const val:ISubscribeOptions = {
      email:false,
      web:false,
      sms:false,
      push:false,
    };
    setSelectedValue(val);
  };
  return (<>
      <MergeCompanyComponent ref={mergeCompanyRef}></MergeCompanyComponent>
      <div className="companyTable">
            <SubscribeModal value={selectedValue} onSubmit={onSubmit} companyId={selectedCompnay} show={isModalShow} setShow={setIsModalShow}/>
             <Table<ICompanyData> extra={extra} filters={filters} searchPlaceholder="Search name, license, domain, EIA or ECID" columns={columns} data={companies} loading={loading} total={total} hook={hook}  />
      </div>
    </>
  );
};
